module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    style: ('font-size:' + _vm.fontSize + 'px')
  }, [_c('i', {
    staticClass: "glyphicon glyphicon glyphicon-info-sign"
  }), _vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-151fe62d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData.vue
// module id = 1074
// module chunks = 1